export default "__VITE_ASSET__BgAO7fNi__"